export const AdminColors = {
  // Page & Surface
  bgPage: '#F5F9FF',
  bgSurface: '#FFFFFF',
  bgHover: '#E7EFFB',

  // Blue palette
  blue900: '#01346F',
  blue800: '#034895',
  blue700: '#005CBC',
  blue600: '#0061C7',
  blue200: '#A9C8F5',
  blue75: '#DAEEFA',
  blue50: '#E8F0FB',
  blue25: '#F3F7FD',

  // Green palette
  green600: '#027C06',
  green400: '#129F14',
  green75: '#CAF3C6',

  // Red palette
  red700: '#AB2B09',
  red500: '#C12C01',
  red400: '#E34119',
  red75: '#FFE5DE',

  // Yellow
  yellow200: '#E5A408',
  yellow50: '#FEF1B9',

  // Gray palette
  gray800: '#2D2D2D',
  gray600: '#4B4B4B',
  gray500: '#585858',
  gray450: '#616161',
  gray400: '#656565',
  gray350: '#818181',
  gray300: '#838383',
  gray200: '#A8A8A8',
  gray150: '#C0C0C0',
  gray100: '#D0D0D0',
  gray50: '#E6E6E6',
  gray25: '#EBEBEB',
  nearWhite: '#F8F8F8',

  // Semantic
  textPrimary: '#2D2D2D',
  textSecondary: '#616161',
  textMuted: '#838383',
  textOnDark: '#FFFFFF',
  textLink: '#005CBC',
  textError: '#C12C01',
  textWarning: '#995211',

  // Border
  borderDefault: '#D0D0D0',
  borderFocus: '#005CBC',
  borderTable: '#D7E5F8',

  // Tag colors keyed by type
  tagBlue: { bg: '#DAEEFA', text: '#01346F' },
  tagGreen: { bg: '#CAF3C6', text: '#0C420B' },
  tagAmber: { bg: '#FEF1B9', text: '#995211' },
  tagRed: { bg: '#FFE5DE', text: '#AB2B09' },
  tagGray: { bg: '#E6E6E6', text: '#4B4B4B' },
  tagTeal: { bg: '#AAD2E2', text: '#1E5A7A' },
  tagPurple: { bg: '#E1E3FD', text: '#31217D' },
  tagOrange: { bg: '#FCECDE', text: '#4D2E0C' },
} as const;
